import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  makeStyles,
  TablePagination,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  table: {
    // marginTop: theme.spacing(3),
    "& thead th": {
      fontWeight: "500",
      color: "black",
      padding: 3,
      borderBottom: "1px solid #a0a092",
      fontSize: 13,

      // backgroundColor: "#989da2",
      // width:'90%'
    },
    "& tbody td": {
      fontWeight: "400",
      fontSize: 12,
      padding: 5,
    },
    "& tbody tr:hover": {
      // backgroundColor: "#fffbf2",
      cursor: "pointer",
    },
    // '& tbody tr:nth-child(even)':{backgroundColor: 'rgb(246, 249, 251)'}
  },
}));

export default function useTable(records, headCells, filterFn) {
  const classes = useStyles();

  const pages = [5, 10, 25];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pages[page]);

  const TblContainer = (props) => (
    <Table className={classes.table}>{props.children}</Table>
  );

  const TblHead = (props) => {
    const { style } = props;
    return (
      <TableHead style={style}>
        <TableRow>
          {headCells.map((headCell) => (
            <TableCell key={headCell.id}>{headCell.label}</TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const TblPagination = () => (
    <TablePagination
      component="div"
      page={page}
      rowsPerPageOptions={pages}
      rowsPerPage={rowsPerPage}
      count={records.length}
      onChangePage={handleChangePage}
      onChangeRowsPerPage={handleChangeRowsPerPage}
    />
  );

  return {
    TblContainer,
    TblHead,
    TblPagination,
  };
}
